import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as companyRoutes } from './companies/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import campaignsRoutes from './campaigns/campaigns.routes';
import { routes as captainRoutes } from './captain/captain.routes';
import AppContainer from './Dashboard.vue';
import Suspended from './suspended/Index.vue';
import NoAccounts from './noAccounts/Index.vue';
import FangateLayout from './fangate/FangateLayout.vue';

export default {
  routes: [
    // -------------------------------------------------------------------------
    // Creator-Chat landing — Fangate 4-column shell at /dashboard.
    // MUST be listed BEFORE the AppContainer route so Vue Router matches this
    // specific path before falling through to the parent wildcard, AND must
    // be top-level (not a child of AppContainer) so Chatwoot's legacy outer
    // sidebar doesn't render around it. The standalone /fangate URL was
    // retired so the marketing word doesn't leak into user-facing URLs.
    // -------------------------------------------------------------------------
    {
      path: frontendURL('accounts/:accountId/dashboard'),
      name: 'home',
      component: FangateLayout,
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
    },
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        ...captainRoutes,
        ...inboxRoutes,
        ...conversation.routes,
        ...settings.routes,
        ...contactRoutes,
        ...companyRoutes,
        ...searchRoutes,
        ...notificationRoutes,
        ...helpcenterRoutes.routes,
        ...campaignsRoutes.routes,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Suspended,
    },
    {
      path: frontendURL('no-accounts'),
      name: 'no_accounts',
      component: NoAccounts,
    },
  ],
};
